import React, { useState, useContext } from "react";
import { MenuContext } from "../contexts/MenuContext";
import "./styles/SongCard.css";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";

function SongCard(props) {
  const {
    data,
    checked,
    setChecked,
    setExpanded,
    expanded,
    setOpenSong,
    openSong,
  } = useContext(MenuContext);

  // Check first if the item has been already checked before
  const defaultChecked = checked.some((e) => e.id === props.dataItem.id);

  // Add/Remove checked item from list
  const handleCheck = (event) => {
    if (expanded === true) {
      setExpanded(false);
    }
    var updatedList = [...checked];
    if (event.target.checked) {
      updatedList = [...checked, props.dataItem];
    } else {
      updatedList.splice(checked.indexOf(props.dataItem), 1);
    }
    setChecked(updatedList);
    console.log("Array size is:" + Object.values(checked).length);
  };

  const openTheSong = () => {
    const newSong = props.dataItem;
    const newSongArr = [...openSong, newSong];
    setOpenSong(newSongArr);
  };

  return (
    <div className="song--card">
      <img className="song--chord" src={props.ChordIcon} />
      <div className="song--body" onClick={openTheSong}>
        <h3 className="song--title">{props.dataItem.title}</h3>
        <p className="song--line--one">{props.dataItem.textLineOne}</p>
        <p className="song--line--two">{props.dataItem.textLineTwo}</p>
        <p className="song--line--one">{props.dataItem.textLineThree}</p>
      </div>
      <label className="song--save">
        <input
          // defaultChecked={defaultChecked}
          checked={defaultChecked}
          type="checkbox"
          className="save--input"
          value={props.dataItem.id}
          onChange={handleCheck}
        />
        <span className="save--icon">
          {props.checker === "done" ? (
            <BookmarkIcon sx={{ fontSize: 40 }} />
          ) : (
            <BookmarkBorderIcon sx={{ fontSize: 40 }} />
          )}
        </span>
      </label>
    </div>
  );
}

export default SongCard;
